import { Grid, Button, RadioGroup, FormControlLabel, Radio, Box, Typography } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
import { RootState, useTSelector } from "rx/store";
import FBTextField from "./FBTextField";
import FBKeyboardDateTimePicker from "./FBKeyboardDateTimePicker";
import FBSwitch from "./FBSwitch";
import { useTranslation } from "react-i18next";
import { donwloadEvent } from "./DownloadsDialog";
import LinkBox from "./LinkBox";
import { useNL } from "utils/NLContext";
import { AppLinks } from "./AppLinks";

const TeamType: React.FC<{ eventId: string }> = ({ eventId }) => {
  const { t } = useTranslation();
  const teamtype = useTSelector(s => s.event.teamtype);
  const { fbSet } = useNL();

  return <Box sx={{ position: 'relative', mt: 3, display: 'inline-block' }}>
    {/* The Box with the border */}
    <Box
      sx={{
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 1,
        padding: 2,
        pt: 2, // extra padding-top for the label
      }}
    >
      {/* The Radio buttons inside */}
      <RadioGroup row value={teamtype ?? "single"} onChange={(_, value) => {
        console.log('calling set', value)
        fbSet(`/eventsdata/${eventId}/data/teamtype`, value);
      }}>
        <FormControlLabel value="single" control={<Radio />} label={t("label.teamtype.single")} />
        <FormControlLabel value="multiple" control={<Radio />} label={t("label.teamtype.multiple")} />
      </RadioGroup>
    </Box>

    {/* The label text floating on the border */}
    <Typography
      variant="caption"
      sx={{
        position: 'absolute',
        top: 0,
        left: 8,
        transform: 'translateY(-50%)',
        backgroundColor: 'background.paper',
        px: 0.5,
        color: 'text.secondary',
        fontSize: '0.75rem'
      }}
    >
      {t("label.teamsizetype")}
    </Typography>
  </Box>
}

const DownloadButton: React.FC<{ eventId: string }> = ({ eventId }) => {
  const { t } = useTranslation();

  return (
    <Button variant="contained" onClick={async () => donwloadEvent}>
      {t("button.eventdownload")}
    </Button>
  );
};
const EventSettingsGeneral: React.FC<{ eventId: string }> = ({ eventId }) => {
  const conf = useSelector((state: RootState) => state.conf);
  const evlink = `https://${conf.hostname}/${eventId}`;
  return (
    <Grid container spacing={2} alignItems="center" direction="row">
      <Grid size={{ xs: 12, sm: 4, lg: 5 }}>
        <FBTextField
          disabletooltip
          fullWidth
          id="eventName"
          path={`/events/${eventId}/name`}
          variant="outlined"
        />
      </Grid>
      <Grid size={{ xs: 12, sm: 8, lg: 7 }}>
        <Box display="flex" flexDirection="row">
          <LinkBox link={evlink} />
          <AppLinks />

        </Box>
      </Grid>
      <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
        <FBKeyboardDateTimePicker
          ampm={false}
          format="DD/MM/YYYY HH:mm"
          id="starttime"
          path={`/events/${eventId}/starttime`}
          slotProps={{
            actionBar: {
              actions: ["today"],
            },
          }}
        />
      </Grid>
      <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
        <FBKeyboardDateTimePicker
          ampm={false}
          format="DD/MM/YYYY HH:mm"
          id="endtime"
          path={`/events/${eventId}/endtime`}
          slotProps={{
            actionBar: {
              actions: ["today"],
            },
          }}
        />
      </Grid>
      <Grid>
        <DownloadButton eventId={eventId} />
      </Grid>
      <Grid>
        <FBSwitch
          id="hidetracks"
          path={`/eventsdata/${eventId}/data/hidetracks`}
        />
      </Grid>
      <Grid>
        <FBSwitch id="hidden" path={`/events/${eventId}/hidden`} />
      </Grid>
      <Grid size={12}>
        <TeamType eventId={eventId} />
      </Grid>
    </Grid >
  );
};

export default EventSettingsGeneral;
